import { Field, Int, ObjectType } from '@nestjs/graphql'

/**
 * One Apple Books promo code in a book's pool (sc-28048).
 *
 * `expirationDate` is what Apple requires us to put in front of the reader before they redeem, and
 * is null for codes added before that requirement existed. It is a calendar day as `YYYY-MM-DD`,
 * NOT an instant: an instant has to be read against a timezone, and the author, the api and the
 * reader do not share one - which expired codes a day early. A code is good THROUGH this date.
 *
 * `claimed` is not a column - it is derived from arc_claimed_download_code - and is what stops the
 * author removing a code a reader is holding.
 */
@ObjectType()
export class BookAppleBooksCodeDto {
  @Field(t => Int)
  id!: number

  @Field()
  code!: string

  @Field({ nullable: true })
  expirationDate?: string

  @Field()
  claimed!: boolean
}
